import React from 'react';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import { applyStyles } from 'util/helpers';
import BlockHeader from 'components/common/BlockHeader';
import i18n from 'i18n';
import imgHowToPhoneIllust2PC1x from 'assets/images/PC/@1x/img_howto_phone_illust2.png';
import imgHowToPhoneIllust2PC2x from 'assets/images/PC/@2x/img_howto_phone_illust2@2x.png';
import imgHowToPhoneIllust2SP2x from 'assets/images/SP/@2x/img_howto_phone_illust2_1@2x.png';
import imgHowToPhoneIllust2SP3x from 'assets/images/SP/@3x/img_howto_phone_illust2_1@3x.png';
import imgHowToPhoneIllust1PC1x from 'assets/images/PC/@1x/img_howto_phone_illust1.png';
import imgHowToPhoneIllust1PC2x from 'assets/images/PC/@2x/img_howto_phone_illust1@2x.png';
import imgHowToPhoneIllust1SP2x from 'assets/images/SP/@2x/img_howto_phone_illust1_1@2x.png';
import imgHowToPhoneIllust1SP3x from 'assets/images/SP/@3x/img_howto_phone_illust1_1@3x.png';
import imgHowToPhoneIllust3PC1x from 'assets/images/PC/@1x/img_howto_illust3.png';
import imgHowToPhoneIllust3PC2x from 'assets/images/PC/@2x/img_howto_illust3@2x.png';
import imgHowToPhoneIllust3SP2x from 'assets/images/SP/@2x/img_howto_illust3_1@2x.png';
import imgHowToPhoneIllust3SP3x from 'assets/images/SP/@3x/img_howto_illust3_1@3x.png';
import Steps from './Steps';

const steps = [
  {
    img: {
      pc1x: imgHowToPhoneIllust1PC1x,
      pc2x: imgHowToPhoneIllust1PC2x,
      sp2x: imgHowToPhoneIllust1SP2x,
      sp3x: imgHowToPhoneIllust1SP3x,
      alt: 'img_howto_phone_illust1'
    },
    p: i18n.t('about:gift.phone.step1', { returnObjects: true })
  },
  {},
  {
    img: {
      pc1x: imgHowToPhoneIllust2PC1x,
      pc2x: imgHowToPhoneIllust2PC2x,
      sp2x: imgHowToPhoneIllust2SP2x,
      sp3x: imgHowToPhoneIllust2SP3x,
      alt: 'img_howto_phone_illust2'
    },
    p: i18n.t('about:gift.phone.step2', { returnObjects: true })
  },
  {},
  {
    img: {
      pc1x: imgHowToPhoneIllust3PC1x,
      pc2x: imgHowToPhoneIllust3PC2x,
      sp2x: imgHowToPhoneIllust3SP2x,
      sp3x: imgHowToPhoneIllust3SP3x,
      alt: 'img_howto_phone_illust3'
    },
    p: i18n.t('about:gift.phone.step3', { returnObjects: true })
  }
];

const Phone = ({ className }) => (
  <div className={className}>
    <BlockHeader>{i18n.t('about:gift:phone.header')}</BlockHeader>
    <div className="phone-content">
      <Steps steps={steps} />
    </div>
  </div>
);

const commonStyle = css``;

const pcStyle = CustomMedia.greaterThan('umedium')`
  ${BlockHeader}{
    margin-top: 66px
  }

  .phone-content {
    margin-top: 40px;
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  ${BlockHeader}{
    margin-top: 27px;
  }

  .phone-content {
    margin-top: 16px;
  }
`;

export default applyStyles(Phone)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/About/Gift/components/Phone.js